import React from 'react';
import { getTrackColorByStateAndDifficulty } from "../../helpers/map";
import { tracksWidth, arrowWidth } from "../../config/defaults";
import { TRACK_DIFFICULTY_BLUE } from "../../config/constants";

const Connector14BBlue14ABlue = ({ state, workState }) => (
   <g id="Track-14B-blue" transform="translate(1638.000000, 946.000000)">
      <g id="line" stroke={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLUE)}
         strokeLinecap="round">
         <path
            d="M85,40 L75.7775171,40.3907832 C45.0564901,41.6925216 16.0463347,26.2295856 0,0 L0,0 L0,0"
            id="Path-6" strokeWidth={tracksWidth}/>
      </g>
   </g>
);

export default Connector14BBlue14ABlue;
